import type { NextPage } from 'next'
import { SampleSearch } from '@/client/modules/SampleSearch'
import { SampleSearchProps } from '@/client/modules/SampleSearch/types'
import { getCMSContent } from '@/client/utils'

const SampleSearchPage: NextPage<SampleSearchProps> = (data) => <SampleSearch {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'SAMPLE_SEARCH')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default SampleSearchPage
